(function (app, ng) {
    app.component("advisorBreakdownComponent",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Dashboard/Components/AdvisorBreakdown/advisor-breakdown.template.html",
            controller: 'advisorBreakdownController',
            bindings: {
                startDate: "<",
                endDate: "<"
            }
        })
        .controller('advisorBreakdownController',
            ["_", "chartColors", "$filter", "marketingTrackerSalesTrackerDashboardApi", "$q", "featureToggleService",
                function (_, chartColors, $filter, marketingTrackerSalesTrackerDashboardApi, $q, featureToggleService) {
                    var $ctrl = this;

                    ng.extend($ctrl, {
                        ui: {
                            loading: false
                        },
                        charts: { chart1: { data: [0] }, chart2: { data: [0] } },
                        colors: ng.copy(chartColors), //chartColors,
                        advisorBreakdownData: {
                            Advisors: [],
                            Products: {
                                AdvisorHeaders: [],
                                SalesSummaryLobModels: []
                            }
                        }
                    });

                    function getStackedChartData(dataGroup) {
                        var seriesData = _
                            .chain(dataGroup)
                            .orderBy(dataGroup, ['LineOfBusinessName'], ['asc'])
                            .reduceRight(function (matrix, lob) {
                                var advPercentage = _
                                    .chain(_.orderBy(lob.SalesSummaryAdvisorModels, ['Order'], ['asc']))
                                    .map(function (advisor) {
                                        return lob.SalesSummaryTotalModel.total_sales === 0 ? 0 : advisor.SalesSummaryTotalModel.total_sales / lob.SalesSummaryTotalModel.total_sales * 100;
                                    })
                                    .value();
                                matrix.push(advPercentage);
                                return matrix;
                            }, [])
                            .unzip()
                            .value();
                        return seriesData;
                    }

                    function _getFormData() {
                        _resetProductionShare($ctrl.advisorBreakdownData.Advisors);
                        _resetProductType($ctrl.advisorBreakdownData.Products);
                    }

                    _resetProductionShare = function (dataGroup) {
                        var dataArray = ng.copy(dataGroup);
                        dataArray.forEach(function (a, i) { a.Index = i; })
                        // Added to allow filtering of sources with no data, and maintain index position for color selection
                        var dataArrayFiltered = _.filter(dataArray, function (a) { return !!a.ProductionAmount })
                        var dataLabels = dataArrayFiltered.map(function (a) { return a.AdvisorName; });
                        var dataShortLabels = dataArrayFiltered.map(function (a) { return _textTruncate(a.AdvisorName, 20, '...'); });
                        var dataInfo = dataArrayFiltered.map(function (a) { return a.ProductionAmount; });
                        var dataColors = ng.copy($ctrl.colors);
                        var dataIndexes = dataArrayFiltered.map(function (a) { return a.Index; });
                        var dataIndexedColors = dataIndexes.map(function (a) { return dataColors[a]; });

                        $ctrl.charts.chart1 = {
                            options: {
                                cutoutPercentage: 75,
                                legend: {
                                    display: true,
                                    position: "bottom",
                                    labels: {
                                        boxWidth: 12,
                                        fontColor: '#5C5C69',
                                        fontSize: 12,
                                        generateLabels: function () {
                                            return dataShortLabels.map(function (a, i) {
                                                return {
                                                    text: a,
                                                    fillStyle: dataIndexedColors[i],
                                                    hidden: false,
                                                    strokeStyle: "#FFFFFF"
                                                };
                                            });
                                        },
                                        padding: 20
                                    }
                                },
                                tooltips: {
                                    callbacks: {
                                        label: function (obj) {
                                            return dataLabels[obj.index] + ": " + $filter('currency')(dataInfo[obj.index], '$', 0);
                                        }
                                    }
                                },
                                responsive: true,
                                maintainAspectRatio: true,
                            },
                            shortLabels: dataShortLabels,
                            labels: dataLabels,
                            data: Object.values(dataInfo),
                            colors: dataIndexedColors.map(function (color) {
                                return {
                                    backgroundColor: color,
                                    hoverBackgroundColor: color,
                                    pointBackgroundColor: color,
                                    pointHoverBackgroundColor: color,
                                    borderColor: color,
                                    hoverBorderColor: color,
                                    pointBorderColor: color,
                                    pointHoverBorderColor: color,
                                }
                            }),
                            type: 'doughnut'
                        };
                    };

                    _resetProductType = function (model) {
                        var dataGroup = model.SalesSummaryLobModels;
                        var dataArray = ng.copy(dataGroup);//slice top n number of records

                        var dataLabels = dataArray.map(function (a) { return a.LineOfBusinessName; });
                        var dataShortLabels = dataArray.map(function (a) { return _textTruncate(a.LineOfBusinessName, 20, '...'); });
                        var series = _
                            .chain(model.AdvisorHeaders)
                            .orderBy(['Order'])
                            .map('Name')
                            .map(_textTruncateBy20)
                            .value();
                        var dataInfo = getStackedChartData(dataGroup);
                        var dataColors = ng.copy($ctrl.colors);

                        $ctrl.charts.chart2 = {
                            options: {
                                cutoutPercentage: 75,
                                legend: {
                                    display: false,
                                    position: "left",
                                    labels: {
                                        boxWidth: 12,
                                        fontColor: '#2A4560',
                                        fontSize: 18,
                                        generateLabels: function () {
                                            return series.map(function (a, i) {
                                                return {
                                                    text: a,
                                                    fillStyle: dataColors[i],
                                                    hidden: false,
                                                    strokeStyle: "#FFFFFF"
                                                };
                                            });
                                        },
                                        padding: 20
                                    }
                                },
                                tooltips: {
                                    callbacks: {
                                        label: function (tooltipItem, data) {
                                            var label = data.datasets[tooltipItem.datasetIndex].label || '';

                                            if (label) {
                                                label += ': ';
                                            }
                                            label += Math.round(tooltipItem.yLabel * 100) / 100;
                                            return label + '%';
                                        }
                                    }
                                },
                                responsive: true,
                                maintainAspectRatio: true,
                                scales: {
                                    xAxes: [{
                                        stacked: true,
                                    }],
                                    yAxes: [{
                                        stacked: true,
                                        max: 100,
                                    }]
                                }
                            },
                            shortLabels: dataShortLabels,
                            labels: dataLabels,
                            data: dataInfo,
                            series: series,
                            type: 'linear'
                        };
                    };

                    var _textTruncate = function (fullString, length, ending) {
                        if (length === null) {
                            length = 50;
                        }
                        if (ending === null) {
                            ending = '...';
                        }
                        var strLength = !!fullString ? fullString.length : 0;
                        if (strLength > length) {
                            return fullString.substring(0, length - ending.length) + ending;
                        } else {
                            return fullString;
                        }
                    };

                    var _textTruncateBy20 = _.partial(_textTruncate, _, 20, '...');

                    $ctrl.$onInit = function () {
                        $ctrl.toggleFeature = featureToggleService.checkEnv();
                        $ctrl.ui.loading = true;
                        const promises = [
                            marketingTrackerSalesTrackerDashboardApi.getAdvisorProductionByDate($ctrl.startDate, $ctrl.endDate),
                            marketingTrackerSalesTrackerDashboardApi.getAdvisorProductBreakdown($ctrl.startDate, $ctrl.endDate)
                        ];
                        $q.all(promises)
                            .then(function (responses) {
                                $ctrl.advisorBreakdownData.Advisors = responses[0];
                                $ctrl.advisorBreakdownData.Products = responses[1];
                                _getFormData();
                            })
                            .catch(function (error) {
                                console.log(error.data)
                            })
                            .finally(function () {
                                $ctrl.ui.loading = false;
                            });
                    }
                }
            ]);
})(window.app, window.angular); //jshint ignore:line